import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
} from "react";
import { ImageData } from "../utils/typeConstants";

interface ImageDataContextType {
  imageData: ImageData[];
  addImageData: (newImageData: ImageData) => void;
  clearImageData: () => void;
  imageIds: string[];
  setUpdatedImageIds: React.Dispatch<React.SetStateAction<string[]>>;
  setImageData: React.Dispatch<React.SetStateAction<ImageData[]>>;
  currentImageUrls: string[];
  setCurrentImageUrls: React.Dispatch<React.SetStateAction<string[]>>;
  hasImageChanged:boolean;
  setHasImageChanged: React.Dispatch<React.SetStateAction<boolean>>;
}

const ImageDataContext = createContext<ImageDataContextType | undefined>(
  undefined
);

export const useImageData = () => {
  const context = useContext(ImageDataContext);
  if (!context) {
    throw new Error("useImageData must be used within an ImageDataProvider");
  }
  return context;
};

interface ImageDataProviderProps {
  children: ReactNode;
}

export const ImageDataProvider: React.FC<ImageDataProviderProps> = ({
  children,
}) => {
  const [imageData, setImageData] = useState<ImageData[]>([]);
  const [updatedimageIds, setUpdatedImageIds] = useState<string[]>([]);
  const [currentImageUrls, setCurrentImageUrls] = useState<string[]>([]);
  const [hasImageChanged, setHasImageChanged] = useState(false);



  // Not needed for creation
  // const { data: apiData, isLoading, error } = useGetImageById();

  // useEffect(() => {
  //   if (apiData) {
  //     setImageData(apiData);
  //     setUpdatedImageIds(apiData.map((image: any) => image.id));
  //   }
  // }, [apiData]);

  const addImageData = (newImageData: ImageData) => {
    setImageData((prevData) => {
      return [...prevData, newImageData];
    });
  };

  const clearImageData = () => {
    setImageData([]);
    setUpdatedImageIds([]);
  };

  const value: ImageDataContextType = {
    imageData,
    addImageData,
    clearImageData,
    imageIds: updatedimageIds,
    setUpdatedImageIds,
    setImageData,
    currentImageUrls,
    setCurrentImageUrls,
    hasImageChanged,
    setHasImageChanged
  };

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Error loading data</div>;
  // }

  return (
    <ImageDataContext.Provider value={value}>
      {children}
    </ImageDataContext.Provider>
  );
};
